<script>

    import BackgroundEmbedMixin from "../../../author/pagesbuilder/mixins/BackgroundEmbedMixin";
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "EmbedElement",
        mixins: [AnimationsMixin,],
        data() {
            return {
                elementType: 'embed',
            }
        },
        computed : {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    selectedMedia: 'Embed',
                    linkData: {},
                    embedMediaData: {},
                    itemVisibilitySettings: null
                }
            },
        },
        methods: {

            getEmbed(){
                return this.myData.embedMediaData && this.myData.embedMediaData.value ? this.myData.embedMediaData.value : '';
            },
            setEmbed(embedData){
                this.changeMyData({embedMediaData: embedData});
            },
        }
    }
</script>
